import { Rect3DRender } from "@visactor/vrender-core/render/symbol";

import { resolveContainerBinding } from "../../../common/explicit-binding";

import { CanvasPickerContribution, CanvasRect3dPicker } from "../constants";

import { DefaultCanvasRect3dPicker } from "./rect3d-picker";

let loadRect3dPick = !1;

export function bindRect3dCanvasPickerContribution(container) {
    var _a;
    loadRect3dPick || (null === (_a = container.isBound) || void 0 === _a ? void 0 : _a.call(container, Rect3DRender)) && (loadRect3dPick = !0, 
    container.bind(CanvasRect3dPicker).toDynamicValue((() => new DefaultCanvasRect3dPicker(resolveContainerBinding(container, Rect3DRender)))).inSingletonScope(), 
    container.bind(CanvasPickerContribution).toService(CanvasRect3dPicker));
}
//# sourceMappingURL=rect3d-module.js.map
